import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { Link } from 'src/app/user/user.model';

export enum DataState {
    ENTERING = 'ENTERING',
    DONE = 'DONE',
}

@Component({
    selector: 'app-family-member',
    templateUrl: './family-member.component.html',
    styleUrls: ['./family-member.component.scss'],
    animations: [trigger('dataChange', [transition(`${DataState.DONE} => ${DataState.ENTERING}`, [style({ opacity: '0' }), animate('200ms ease', style({ opacity: '1' }))])])],
})
export class FamilyMemberComponent implements OnDestroy {
    destroy$ = new Subject();

    @Input() link: Link;

    @Output() handleEdit = new EventEmitter();

    @Output() handleDelete = new EventEmitter();

    @Output() handleForceAccept = new EventEmitter();

    constructor(private router: Router) {}

    redirectToProfile(userId: string): void {
        const url = this.router.serializeUrl(this.router.createUrlTree([`/user-update/${userId}`]));
        window.open(window.location.origin + url, '_blank');
    }

    editFamilyLink(link: Link): void {
        this.handleEdit.emit(link);
    }

    deleteFamilyLink(link: Link): void {
        this.handleDelete.emit(link);
    }

    forceAcceptFamilyLink(link: Link): void {
        this.handleForceAccept.emit(link);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
